var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { class: _vm.optionsClasss, on: { click: _vm.handleOptionsClick } },
    [
      _vm._t("default", [
        _vm._v("\n    " + _vm._s(_vm.label || _vm.value) + "\n  ")
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }